import React from 'react';
import BookDemoFormScreen from '@/js/screens/BookDemoFormScreen';
import BookDemoCalenderScreen from '@/js/screens/BookDemoCalenderScreen';

// Testimonials Data
const testimonials = [
  {
    quote:
      "MakerSharks didn't just help us find manufacturers, the RFQ and PO automation saved us 6+ months of back-and-forth. Total game changer",
    name: 'Ahmed Taka',
    title: 'CEO, Ape Fitness',
    image: 'https://via.placeholder.com/40',
  },
  {
    quote:
      'It is like having a team of manufacturing engineers working for you. We cut sourcing time in half and eliminated painful manual coordination.',
    name: 'Eduardo Latouche',
    title: 'Director of Technology Research & Development, Kytopen',
    image: 'https://via.placeholder.com/40',
  },
];

const screenEnum = {
  FORM: 'FORM',
  CALENDER: 'CALENDER',
};

const BookDemo = () => {
  const [screen, setScreen] = React.useState(screenEnum.FORM);
  const [data, setData] = React.useState({});

  const screenFunction = () => {
    switch (screen) {
      case screenEnum.FORM:
        return <BookDemoFormScreen setScreen={setScreen} setData={setData} />;

      case screenEnum.CALENDER:
        return <BookDemoCalenderScreen data={data} />;

      default:
        break;
    }
  };

  return (
    <div className="flex flex-row justify-center gap-8 p-8 bg-gray-50 min-h-screen font-roboto ">
      {/* Testimonials Section */}
      <div className="w-[550px] rounded-xl shadow p-6 bg-veryVeryLightPurple bg-opacity-70 min-h-[calc(85vh)]">
        <h2 className="text-3xl font-medium text-darkerPurple">
          Makersharks saves months
        </h2>
        <p className="text-gray-500 mb-4 text-base font-light">
          See what our customers have to say!
        </p>

        {testimonials.map((testimonial, idx) => (
          <div key={idx} className="bg-gray-50 p-4 rounded-lg mb-4">
            <p className="text-xl font-medium">"{testimonial.quote}"</p>
            <div className="mt-6 flex items-center gap-3">
              <img
                src={testimonial.image}
                alt={testimonial.name}
                className="rounded-full w-10 h-10"
              />
              <div>
                <p className="text-base font-semibold">{testimonial.name}</p>
                <p className="text-sm font-light text-gray-600">
                  {testimonial.title}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Form Section */}
      <div
        className={`w-[650px] bg-white rounded-xl shadow py-8 px-12 min-h-[calc(85vh)]`}
      >
        {screenFunction()}
      </div>
    </div>
  );
};

export default BookDemo;
